'use client';
import { configureStore } from '@reduxjs/toolkit';

import {
  assessmentApi,
  capitalRequestApi,
  capitalRequestMatchApi,
  championApi,
  growthPlanApi,
  inviteApi,
  landingApi,
  notificationApi,
  opportunityApi,
  org,
  sourcingApi,
  supplierApi,
  supplierRequestApi,
  supplierRequestMatchApi,
  userApi,
  reportApi,
  adminApi,
} from '../api';

export const makeStore = () =>
  configureStore({
    reducer: {
      [notificationApi.reducerPath]: notificationApi.reducer,
      [userApi.reducerPath]: userApi.reducer,
      [supplierRequestApi.reducerPath]: supplierRequestApi.reducer,
      [capitalRequestApi.reducerPath]: capitalRequestApi.reducer,
      [org.reducerPath]: org.reducer,
      [supplierRequestMatchApi.reducerPath]: supplierRequestMatchApi.reducer,
      [capitalRequestMatchApi.reducerPath]: capitalRequestMatchApi.reducer,
      [assessmentApi.reducerPath]: assessmentApi.reducer,
      [supplierApi.reducerPath]: supplierApi.reducer,
      [opportunityApi.reducerPath]: opportunityApi.reducer,
      [championApi.reducerPath]: championApi.reducer,
      [growthPlanApi.reducerPath]: growthPlanApi.reducer,
      [landingApi.reducerPath]: landingApi.reducer,
      [inviteApi.reducerPath]: inviteApi.reducer,
      [sourcingApi.reducerPath]: sourcingApi.reducer,
      [reportApi.reducerPath]: reportApi.reducer,
      [adminApi.reducerPath]: adminApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .concat(notificationApi.middleware)
        .concat(sourcingApi.middleware)
        .concat(championApi.middleware)
        .concat(userApi.middleware)
        .concat(growthPlanApi.middleware)
        .concat(landingApi.middleware)
        .concat(inviteApi.middleware)
        .concat(supplierRequestApi.middleware)
        .concat(supplierApi.middleware)
        .concat(capitalRequestApi.middleware)
        .concat(org.middleware)
        .concat(supplierRequestMatchApi.middleware)
        .concat(capitalRequestMatchApi.middleware)
        .concat(opportunityApi.middleware)
        .concat(assessmentApi.middleware)
        .concat(reportApi.middleware)
        .concat(adminApi.middleware),
  });

export type AppStore = ReturnType<typeof makeStore>;
